import { Box, styled } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";
import { IoIosRefresh } from "react-icons/io";
import { TbCalendarTime } from "react-icons/tb";

export const ContainerNumber = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "22px",
  fontWeight: 600,
  lineHeight: "28px",
  textAlign: "left",
}));

export const ContainerBox = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",
}));

interface MainDivProps {
  canClickIt?: boolean;
}
export const MainDiv = styled("div")(({ canClickIt = true }: MainDivProps) => ({
  background: "#F2F4F7",
  borderRadius: "8px 8px 0px 0px",
  display: "flex",
  padding: "8px",
  cursor: canClickIt ? "pointer" : "not-allowed",

  "&:hover": {
    background: "#66708526",
  },

  "@media (max-width: 1023px)": {
    padding: "8px 16px",
  },
}));

export const CalendarIcon = styled(TbCalendarTime)(() => ({
  marginRight: "6px",
  color: "#475467",
}));

export const RefreshIcon = styled(IoIosRefresh)(() => ({
  marginRight: "6px",
  color: "#475467",
}));

export const Information = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
  textAlign: "left",
}));

export const SecondInformation = styled(Information)(() => ({
  color: colors.gray500,
  fontWeight: 600,
  letterSpacing: "0.1px",
}));

export const HiddenBoxComponent = styled(Box)(() => ({
  "@media (max-width: 1023px)": {
    display: "none !important",
  },
}));

export const HiddenBoxWrapper = styled(Box)(() => ({
  "@media (min-width: 1024px)": {
    display: "none !important",
  },
}));

export const useStyles = makeStyles(() => ({
  headerInfoAlign: {
    alignItems: "center",
    display: "flex",
  },
  icon: {
    height: "16px !important",
    width: "16px !important",

    "@media (max-width: 500px)": {
      height: "24px !important",
      width: "24px !important",
    },
  },
  containerImg: {
    margin: "0px 16px",
  },
}));
